import { render, staticRenderFns } from "./AddSubscriptionTypeModal.vue?vue&type=template&id=21146d23&"
import script from "./AddSubscriptionTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddSubscriptionTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports